import React, { useState, useEffect, useMemo, useCallback } from "react";
import { NavLink, useHistory } from "react-router-dom";

import Logo from './../img/logos/logo_mawared_full_BLUE.svg'
// import LogoResp from './../img/logos/logo_initials_BLUE.svg'
import LogoResp from './../img/logos/logo_mawared_MINI_OrangeBlue.svg'
// import Logo2 from './../img/logos/logo_mawared_fullY_WHITE.svg'
// ../img/logos/logoMawared.svg
import LogoResp2 from './../img/logos/logo_mawared_MINI_White.svg'
import Icon from "@mdi/react";
import {
  Button,
  ClickAwayListener,
  ListItemIcon,
  MenuItem,
  Tooltip,
} from "@mui/material";
import "../css/menu.css";
import { useAlert, useAlertState } from "../contexts/alertContext";
import axios from "axios";
import VerticalScrollableTabs from "../compo/vertical_scrollabl_items";
import ResetPwd from "./change_pass";
import useLogout from "../hooks/useLogout";
import { useColorMode } from "../ThemeContext.js";

const MainMenu = React.memo(({ param, ...props }) => {
  const [anchorEl, setAnchorEl] = useState(null);
   const { toggleColorMode, mode } = useColorMode();

  var index = props.menu.findIndex((obj) => obj.level === 1);
  if (index < 0) index = 0;

  const [showSubMenu, setShowSubMenu] = useState(
    window.location.pathname !== "/"
      ? window.location.pathname.split("/")[1]
      : props.menu[index].id ?? ""
  );

  // Séparer les actions et les états
  const { handleOpenMenu, handleNoMenu } = useAlert();
  const { openMenu, noMenu, hideMenu } = useAlertState();
  const { handleHideMenu } = useAlert();

  const mdi = require("@mdi/js");
  const Gfunc = require("../Gfunc");
  const history = useHistory();

  const handleNavigate = (item, child) => {
    const currentPath = window.location.pathname;
    const newPath = `/${item.id}/${child.id}`;

    if (currentPath === newPath) {
      history.replace("/temp");
      setTimeout(() => history.replace(newPath), 0);
    } else {
      history.push(newPath);
    }
  };

  const Logout = useLogout(param, Gfunc);

  function useWindowSize() {
    const [windowSize, setWindowSize] = useState({
      width: window.innerWidth,
      height: window.innerHeight,
    });

    useEffect(() => {
      function handleResize() {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }

      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);

    return windowSize;
  }

  const size = useWindowSize();

  const HandleChangeMenu = useCallback(() => {
    const div = document.getElementById("resizable-div");
    if (openMenu) {
      div.classList.toggle("sidebar");
      div.classList.toggle("sidebarHide");
    }
    else {
      div.classList.toggle("sidebarResp");
      div.classList.toggle("sidebarRespHide");
    }
  }, [openMenu]);

  // Fonction pour gérer le clic sur "Mode compact" et fermer le menu
  const handleCompactModeClick = useCallback(() => {
    handleNoMenu(!noMenu);
    HandleChangeMenu();
    setAnchorEl(null); // Fermer le menu
  }, [handleNoMenu, noMenu, HandleChangeMenu]);

  // Memoized menuItems for rendering performance
  const memoizedMenuItems = useMemo(() => {
    return [
      (!(size.width <= Gfunc.smallScreen)) && (
        <MenuItem onClick={handleCompactModeClick} key="compact-mode">
          <ListItemIcon>
            <Icon path={(!noMenu) ? mdi.mdiMenuOpen : mdi.mdiMenuClose} color="grey" size="22px" />
          </ListItemIcon>
          {(!noMenu) ? "Mode compact" : "Menu rapide"}
        </MenuItem>
      ),
      <ResetPwd param={param} key="reset-pwd" />,
      { divider: true, key: "divider" },
      <MenuItem onClick={Logout} key="logout">
        <ListItemIcon>
          <Icon path={mdi.mdiLogout} color="grey" size="22px" />
        </ListItemIcon>
        Déconnexion
      </MenuItem>,
    ];
  }, [param, noMenu, Logout, size, handleCompactModeClick, Gfunc.smallScreen]);

  const handleClick = (val) => {
    if (val !== showSubMenu) {
      setShowSubMenu(val);
    }
  };

  const DynamicIcon = ({ iconName }) => {
    if (typeof iconName === "string")
      return <Icon path={mdi[iconName]} size="22px" color="white" />;
    else return iconName;
  };

  const HandleResponsive = () => {
    handleOpenMenu(!openMenu);
    const div = document.getElementById("resizable-div");
    if (!noMenu) {
      div.classList.toggle("sidebar");
      div.classList.toggle("sidebarResp");
    }
    else {
      div.classList.toggle("sidebarHide");
      div.classList.toggle("sidebarRespHide");
    }
  };

  // console.log('menu', props.menu)

  // Memoize the menu.map to prevent unnecessary re-renders
  const memoizedMenu = useMemo(() => {
    return props.menu.map((item, index) => (
      <div key={"nav" + index} className="nav-item">
        <NavLink
          aria-current="page"
          to={`/${item.id}`}
          id={item.id}
          onClick={() => handleClick(item.id)}
        >
          {showSubMenu === item.id ? (
            <Icon path={mdi.mdiMenuDown} size="20px" />
          ) : (
            <Icon path={mdi.mdiMenuRight} size="20px" />
          )}
          <div className={"mainIcon"}> <DynamicIcon iconName={item.icon} /></div>

          {openMenu && <span> {item.parent}</span>}
        </NavLink>
        {showSubMenu === item.id && (
          <div className={"sub-nav-group"}>
            {item.children.map((child, childIndex) => (
              <Tooltip
                key={"wrapper" + childIndex}
                title={!openMenu ? child.child : ""}
                arrow
                disableInteractive
                placement="right"
              >
                <div className="sub-nav-item-wrapper">
                  <NavLink
                    key={childIndex}
                    to={`/${item.id}/${child.id}`}
                    className="sub-nav-item"
                    activeClassName="sub-nav-item-selected"
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavigate(item, child);
                    }}
                  >
                    <DynamicIcon iconName={child.icon} />
                    {openMenu && <span>{child.child}</span>}
                  </NavLink>

                </div>
              </Tooltip>
            ))}
          </div>
        )}
      </div>
    ));
  }, [props.menu, openMenu, showSubMenu, mdi]);

  return (
    !hideMenu && <ClickAwayListener
      onClickAway={() => {
        if (noMenu || size.width <= Gfunc.smallScreen) { handleOpenMenu(false); handleHideMenu(true); }
      }}
    >
      <div id="resizable-div" className={(noMenu || size.width <= Gfunc.smallScreen) ? `${openMenu ? "sidebarHide" : "sidebarRespHide"}${hideMenu ? " hidebar" : ""}` : `${openMenu ? "sidebar" : "sidebarResp"}`}>
        {/* top logo header  */}
        <div
          id={openMenu ? "head-men" : "head-men2"}
          onClick={HandleResponsive}
        >

          {mode === "dark" ? (
            openMenu ? (
              // <img src={Logo} alt="logo" />
                <img src={LogoResp} alt="logo" />
            ) : (
              <img src={LogoResp} alt="logo" />
            )
          ) : (
            openMenu ? (
              // <img src={Logo2} alt="logo" />
               <img src={LogoResp2} alt="logo" />
           
            ) : (
              <img src={LogoResp2} alt="logo" />
            )
          )}

        </div>

        <div className={openMenu ? "nav-group" : "nav-group-resp"}>
          {memoizedMenu}
        </div>

        <div className="logout-section">
          <div
            className={`logout-button ${!openMenu ? "centered" : "start"}`}
            onClick={Logout}
          >
            <Icon path={mdi.mdiLogout} size="22px" color="white" />
            {openMenu && <span>Déconnexion</span>}
          </div>
        </div>

      </div>

    </ClickAwayListener>

  );
});

export default MainMenu;